import { useEffect } from 'react'
import isMobile from '@/utils/is-mobile'

const useIsMobile = () => {
  useEffect(() => {}, [])
  return isMobile()
}

export default useIsMobile
